export interface ICode {
	code: string;
	name: string;
	codeId: number;
	status: boolean;
}

export interface IChildCode {
	code: string;
	name: string;
	codeId: number;
	parent: number;
	status: boolean;
}

export interface IVoteCount {
	partyId: number;
	votes: number;
	label: string;
	logo: string;
}

export interface IPartyVotes {
	id: number;
	votes: IVoteCount[];
}

export interface IResultSummary {
	DataVotersOnRegister: number; // done
	DataAccreditedVoters: number; // done
	DataBallotPapersIssuedToPoolingUnit: number; // done
	DataUnusedBallotPapers: number; // done
	DataRejectedBallot: number; // done
	DataTotalValidVotes: number; // done
	DataTotalUsedBallotPapers: number; // done
}

export const defaultSummary: IResultSummary = {
	DataVotersOnRegister: 0,
	DataAccreditedVoters: 0, // done
	DataBallotPapersIssuedToPoolingUnit: 0, // done
	DataUnusedBallotPapers: 0, // done
	DataRejectedBallot: 0, // done
	DataTotalValidVotes: 0, // done
	DataTotalUsedBallotPapers: 0, // done
};

export type stageEnumType = 'Child' | 'Party Votes';

export type ursType =
	| 'Select Election'
	| 'Select Result Type'
	| 'Select Constituent Metadata'
	| 'Upload Result'
	| 'Preview Uploaded File'
	| 'Upload Result Status'
	// | 'Add Result Summary'
	// | 'Add Party Vote Count'
	| 'Preview'
	// | 'Party Vote Summary'
	| 'Election Result Submission Status';

export const handleBackFunc = (stage: ursType): ursType => {
	switch (stage) {
		case 'Select Result Type':
			return 'Select Election';
		case 'Select Constituent Metadata':
			return 'Select Result Type';
		case 'Upload Result':
			return 'Select Constituent Metadata';
		case 'Upload Result Status':
			return 'Upload Result';
		case 'Preview Uploaded File':
			return 'Upload Result';
		// case 'Add Result Summary':
		//   return 'Upload Result'
		// case 'Add Party Vote Count':
		//   return 'Add Result Summary'
		// case 'Party Vote Summary':
		//   return 'Preview'
		default:
			return 'Select Election';
	}
};

export interface IStageArray {
	stage: ursType;
	isComplete: boolean;
}
